module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-right-3.173e2c92.png";